<footer class="d-flex justify-content-center footer-container">
  <!-- No es usuario -->
  <div class="footer-center-options">
    <br />
    <div class="vertical-text">
      <img
        width="300px;"
        class="img-footer"
        src="../../../../assets/images/logo-negativo-kaleido.png"
        alt=""
      />
      <!-- <img
        width="140px"
        class="img-footer"
        src="../../../../assets/images/logo-infodec.png"
        alt=""
      /> -->
    </div>
    <p class="right-text">
      © Infoverse Studio Event VR Derechos reservados para Kaleido Lab SAS. –
      Registro Ddna 13-91-446
    </p>
  </div>
</footer>
